
import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import RecipeService, { FullData, Recipe } from '@/services/recipes.service';

@Component
export default class RoundLabelValues extends Vue {
  @Prop() private model!: Recipe;

  updateValue() {
    const value = this.model.round_label_values;
    RecipeService.updateOne(this.model.id, {
        round_label_values: value,
      }).then((data:FullData) => {
            this.$store.commit('updateRecipe', data.label);
            this.$store.commit('updateTable', data.table);
      }).catch(error => {
        console.log(error);
      });
  }
}
